import { KibanaIframeLayout } from '../../components/analytics/KibanaIframeLayout';

export default () => (
    <KibanaIframeLayout
        pageName="Loyalty Analytics"
        pageDescription="Useful insights into how loyalty is used by your customers."
        dashboardId={import.meta.env.KIBANA_LOYALTY_DASHBOARD_ID}
    />
);
